
jQuery(document).ready(function(){
   setInterval(function(){ 
     if($('div#CartDrawer .drawer__scrollable #drawer-upsell').length == 0){
jQuery('div#CartDrawer .drawer__scrollable').append(jQuery('div#drawer-upsell').clone())  ;



         $('.upsell-add-to-cart-form').each(function() {
      new theme.AjaxProduct($(this));
    });

    
    $('.upsell-add-to-cart-btn').click(function(){
      var productId = $(this).parent().attr('product-id');

       setTimeout(function(){ 
      
            $('.upsell-product-card[data-product-id="' + productId + '"]').remove();
      }, 1000);

      setTimeout(function(){ 
            $('.upsell-product-card[data-product-id="' + productId + '"]').remove();
      }, 2000);
      
    }); 
     }

}, 1000);

});

jQuery(document).ready(function(){
jQuery(document).scroll(function() {
    $('.jdgm-rev__content').each(function() {
    var updatedText = $(this).html().replace(/‚Äô/g, "'");
      var updatedText = updatedText.replace('üòÇ', "");
    $(this).html(updatedText);
  });

 setInterval(function(){ 
  $('.spf-product-card__title').each(function() {
    let text = $(this).text();
    if (text.includes('Bundle') || text.includes('Sleep Set') || text.includes('& Weighted Blanket')) {
        $(this).closest('.spf-product-card').addClass('is-bundle');
    }
});
}, 1000);

    
}); 
 


});
var ur = window.location.href;
if(ur.includes('/product') && !document.title.includes('Jumper')){
  
jQuery(document).ready(function(){

   setInterval(function(){ 

     if(jQuery('.premium-dog-car-bed .variant-input[data-value="M/L"] input:checked').length == 0){
       
     }
   if(jQuery('.product-single__form.for-presale').length &&  jQuery('.premium-dog-car-bed .variant-input[data-value="M/L"] input:checked').length == 0){
     jQuery('.add-to-cart').text("BUY PRE-SALE")
  }   
else if(jQuery('.add-to-cart[disabled]').eq(0).length == 0){
  
  jQuery('.add-to-cart').text("BUY NOW")
  
}
     else{
       jQuery('.add-to-cart').text("SOLD OUT") 
     }
     
}, 50);
});
}


var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

    setInterval(function(){ 

      if(jQuery('.variant-input-wrap input[type=radio][value="Bone"]:checked+label').length){
        
        jQuery('.variant-input[data-value="M/L"]').hide();
      }
      else{
        jQuery('.variant-input[data-value="M/L"]').show();
      }
      if(jQuery('.product__price--compare').eq(0).html() != null){
        var ccprice = parseFloat(jQuery('.product__price--compare').eq(0).html().trim().substring(1));
        var ssprice = parseFloat(jQuery('html .sale-price').eq(0).html().trim().substring(1));
      var savedd = ccprice - ssprice;
      jQuery('span.price-saved-amount span').html('$' + savedd.toFixed(2));
      }
      else{
        var ccprice = 0;
      }
      
      

      
var x = jQuery('.product-single__variants').eq(0).prop('selectedIndex');
jQuery('.product-single__variants option').eq(x).attr('data-stock');

   if(jQuery('.product-single__variants option').eq(x).attr('data-stock') == "true"){
       jQuery('body').addClass('show-low-stock')
     }
     else{
       jQuery('body').removeClass('show-low-stock')
     }
}, 100);
   


$('select#SingleOptionSelector-6985734848585-option-1').change(function(){
  var ind = $(this).prop('selectedIndex');
  jQuery('a.product__thumb').eq(ind).click();
}); 
$('select#SingleOptionSelector-6985734422601-option-1').change(function(){
  var ind = $(this).prop('selectedIndex');
  jQuery('a.product__thumb').eq(ind).click();
});    
}); 
}

function hasTreatParameter() {
    if (document.cookie.includes("discount_code=FREE-MWJ")) {
        return true;
    } else {
        return false;
    }
}

if (hasTreatParameter()) {
    sessionStorage.setItem("hasJumper", "true");
}


function hasBowlParameter() {
    if (document.cookie.includes("discount_code=VIP-BOWLGIFT")) {
        return true;
    } else {
        return false;
    }
}

if (hasBowlParameter()) {
    sessionStorage.setItem("hasBowl", "true");
}


var ur = window.location.href;
if(sessionStorage.getItem('hasBowl') || sessionStorage.getItem('hasJumper') ){
  jQuery(document).ready(function(){
$('form button.add-to-cart').click(function(e){
  e.preventDefault()
  if(sessionStorage.getItem('hasBowl')){
    
var values = [41575333757001, 41575333789769, 41575333822537];
var randomValue = values[Math.floor(Math.random() * values.length)];
var cId = $('.product-single__form').attr('variant-id');

function checkProductsInCarts(callback) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const productIds = [41575333757001, 41575333789769, 41575333822537];
            const exists = cart.items.some(item => productIds.includes(item.id));
            callback(exists);
        })
        .catch(error => console.error('Error fetching the cart:', error));
}

checkProductsInCarts(function(exists) {
    if (exists && !ur.includes('bundle')) {
      
        window.location.href = "https://www.sashbeds.com/cart/add?id[]="+cId
    } 
    else {
      
      if(ur.includes('bundle') || ur.includes('bed-weighted-blanket')){
        
        window.location.href = "https://www.sashbeds.com/cart/add?id[]=" + randomValue
      }
      else{
        
         window.location.href = "https://www.sashbeds.com/cart/add?id[]="+cId+"&id[]=" + randomValue
      }
        
    }
});

    
 
  }
else if(sessionStorage.getItem('hasJumper')){  
if($('body').hasClass('premium-teddy-bed') || ur.includes('/products/boucle-luxury-comforting-bed')){

var values = [40545893548105, 40545893482569, 40545893580873, 40545893515337];
var randomValue = values[Math.floor(Math.random() * values.length)];
var SM = randomValue

var values = [40545894105161, 40545894039625];
var randomValue = values[Math.floor(Math.random() * values.length)];
var L = randomValue  

var values = [40545894137929, 40545894072393];
var randomValue = values[Math.floor(Math.random() * values.length)];
var XL = randomValue    
    
var cId = $('.product-single__form').attr('variant-id');
  

if($('.variant-input-wrap[name="Size"] input:checked').val() == "XL"){
  randomValue = XL;
}
else if($('.variant-input-wrap[name="Size"] input:checked').val() == "L"){
  randomValue = L;
}  
  else{
      randomValue = SM;
  }
  
function checkProductsInCart(callback) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const productIds = [40545893548105, 40545893482569, 40545893580873, 40545893515337, 40545894105161, 40545894039625, 40545894137929, 40545894072393];
            const exists = cart.items.some(item => productIds.includes(item.id));
            callback(exists);
        })
        .catch(error => console.error('Error fetching the cart:', error));
}

checkProductsInCart(function(exists) {
    if (exists) {
        window.location.href = "https://www.sashbeds.com/cart/add?id[]="+cId;
    } else {
      
      
         window.location.href = "https://www.sashbeds.com/cart/add?id[]="+cId+"&id[]=" + randomValue
    }
});

    
}
   else{
    var cId = $('.product-single__form').attr('variant-id');
    window.location.href = "https://www.sashbeds.com/cart/add?id[]="+cId;
  }
  }  
 
  

}); 
});
}

var ur = window.location.href;
var currency = "$"


  jQuery(document).ready(function(){
    if(document.body.className.includes('jumper')){
     setTimeout(function(){ 
jQuery('.variant-input-wrap .variant-input label').eq(4).click(); 
}, 100);
     jQuery('.variant-input-wrap .variant-input label').eq(1).click(function(){
  jQuery('.variant-input-wrap .variant-input label').eq(2).click(); 
    }); 
 }
});



/*
TIMER

var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){
const targetDate = new Date(2023, 09, 05, 23, 59, 0);
const timerContainer = document.getElementById('sashbeds-prod-banner-timer');

function updateTimer() {
  const now = new Date();
  const timeRemaining = targetDate - now;

  if (timeRemaining <= 0) {
    clearInterval(timerInterval);
    timerContainer.classList.add('hide');
    $('#sashbeds-prod-banner-timer').hide();
    return;
  }

  const hoursElem = document.getElementById('hours');
  const minutesElem = document.getElementById('minutes');
  const secondsElem = document.getElementById('seconds');

  // Calculate the remaining hours, minutes, and seconds
  const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  // Update the timer elements with the calculated values
  hoursElem.textContent = hours;
  minutesElem.textContent = minutes;
  secondsElem.textContent = seconds;
}


// Update the timer every second
const timerInterval = setInterval(updateTimer, 1000);

// Call the updateTimer function once to update the timer immediately
updateTimer();

});
}
*/

var ur = window.location.href;
if(ur.includes('/products/calming-dog-bed')){
  jQuery(document).ready(function(){
     setTimeout(function(){ 
//jQuery('.variant-input-wrap .variant-input label').eq(1).click(); 
}, 100);
 
});

}

var ur = window.location.href;
if(ur.includes('/cart')){
  jQuery(document).ready(function(){
    
var prodNames = jQuery('.cart__product-name');
for(var i = 0; i < prodNames.length; i++){
if(prodNames.eq(i).html().includes('Add-on') && prodNames.eq(i).closest('.cart__row').next().find('.cart__product-name').html().trim() == 'Calming Dog Bed'){
prodNames.eq(i).closest('.cart__row').next().addClass('no-remove');
  prodNames.eq(i).closest('.cart__row').addClass('no-qty-pointer');
}

  
if(prodNames.eq(i).html().includes('PAW Complete') && prodNames.eq(i).closest('.cart__row').next().find('.cart__product-name').html().trim() == 'Calming Dog Bed'){
prodNames.eq(i).closest('.cart__row').next().addClass('no-remove');
  prodNames.eq(i).closest('.cart__row').addClass('no-qty-pointer');
}  
} 



$('.cart__product-meta a.btn.btn--tertiary.btn--small').click(function(){
  function updateCartQuantity(variantId, newQuantity) {
  var data = {
    updates: {}
  };
  data.updates[variantId] = newQuantity;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    // Check the response to see if the update was successful
    if (data.status === 'ok') {
      console.log('Cart updated successfully');
    } else {
      console.error('Cart update failed');
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

// Example usage:
var variantId = '40579692494921';

var sum = 0;
var curId = $(this).closest('.cart__row').attr('data-id');
$('[data-product-id="4531816529993"] input').each(function() {
  var inputValue = parseFloat($(this).val());
  if (!isNaN(inputValue) && curId != $(this).closest('.cart__row').attr('data-id')) {
    sum += inputValue;
  }
});      
var newQuantity = sum;
updateCartQuantity(variantId, newQuantity);
}); 
    /*
jQuery('.cart__product-meta a').click(function(e){
  if(!jQuery('body').hasClass('removing')){
   
    var thisTitle = jQuery(this).closest(".cart__row").find('.cart__product-name').eq(0).html();
     var prevTitle = jQuery(this).closest(".cart__row").prev().find('.cart__product-name').eq(0).html();
   
  if(prevTitle != null && (prevTitle.includes('Add-on') || prevTitle.includes('PAW Complete')  ) ){
     e.preventDefault();
    jQuery('body').addClass('removing');
     jQuery(this).closest(".cart__row").prev().find('.cart__product-meta a').eq(0).click();
    
  }
    else{
      jQuery('body').addClass('removing');
    }
  }
    
}); 
*/
});
}
// bundle upsell behavior
  jQuery(document).ready(function(){ 
var ur = window.location.href;
 
if(ur.includes('/product')){
  

if(ur.includes('/products/calming-dog-bed-bundle') || 
   ur.includes('calming-dog-bed-spare-cover-bundle') || 
   ur.includes('calm-cleanse-bundle') || 
   ur.includes('car-bed-pet-odour-eliminator-bundle') || 
  ur.includes('calming-dog-bed-premium-dog-car-bed-bundle') ||
(jQuery('#is-bundle') != null && jQuery('#is-bundle').html().includes('true'))){


 setTimeout(function(){ 
   
 var src = jQuery('.variant-input-wrap select option:selected').eq(0).attr('featured-image-src').replace('products/','').split('.')[0];
   if(!ur.includes('/products/calming-dog-bed-bundle') &&  !ur.includes('calming-dog-bed-spare-cover-bundle')){
     
         jQuery('a.product__thumb[href*="'+src+'"]').eq(0).click();
   }
   if(ur.includes('calming-dog-bed-spare-cover-bundle')){
     jQuery('a.product__thumb').eq(0).click();
   }

}, 1000);

   
   var variant1Presale = parseInt(jQuery('.variant-input-wrap select option:selected').eq(0).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(0).attr('availability') == "continue"
    var variant2Presale = parseInt(jQuery('.variant-input-wrap select option:selected').eq(1).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(1).attr('availability') == "continue"
  var variant2SoldOut  = parseInt(jQuery('.variant-input-wrap select option:selected').eq(1).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(1).attr('availability') == "deny";
  var variant1SoldOut = parseInt(jQuery('.variant-input-wrap select option:selected').eq(0).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(0).attr('availability') == "deny";


  if(variant1SoldOut || variant2SoldOut){
     jQuery('.product-single__form').eq(0).addClass('sold-out-bundle');
    jQuery('.product-single__form').eq(0).removeClass('two-pre-sale');
    jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
  }
    else{
      jQuery('.product-single__form').eq(0).removeClass('sold-out-bundle');
    
    
  if(variant1Presale && variant2Presale){
        jQuery('.product-single__form').eq(0).addClass('two-pre-sale');
        jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
  }
   else if(variant1Presale || variant2Presale){
     jQuery('.product-single__form').eq(0).addClass('one-pre-sale');
  }
  
  else{
    jQuery('.product-single__form').eq(0).removeClass('two-pre-sale');
    jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
   
  }

      }

updatePrice()
     setTimeout(function(){ 
updatePrice()
}, 1000);
 function updatePrice(){
     var pr1 = parseFloat(jQuery('.variant-input-wrap select option:selected').eq(0).attr('data-price'))
    var pr2 = parseFloat(jQuery('.variant-input-wrap select option:selected').eq(1).attr('data-price'));

    var cpr1 = parseFloat(jQuery('.variant-input-wrap select option:selected').eq(0).attr('data-compare-price'))
    var cpr2 = parseFloat(jQuery('.variant-input-wrap select option:selected').eq(1).attr('data-compare-price'));

   
  
   var discc = 0;
    var cdiscc = cpr1 + cpr2 - pr1 - pr2;
   var addDisc = 0;


if(window.location.href.includes('/calming-bed-calming-spare-cover-car-bed')){
  var pr3 = parseFloat(jQuery('.variant-input-wrap select option:selected').eq(2).attr('data-price'));
     var discc = 0;
   var cdiscc = 20500;
   var addDisc = 0;
}
   
   if(window.location.href.includes('/calming-dog-bed-bundle')){
     var discc = 0;

     var addDisc = 0;
   }

   if(window.location.href.includes('/calm-cleanse-bundle')){
     var discc = 0;
     var cdiscc = 6200;
     var addDisc = 0;
   }

   
   if(window.location.href.includes('/luxury-boucle-dog-bed-bundle')){
    
     var discc = 0000;
     var addDisc = 0000;
   }

    if(window.location.href.includes('/luxury-boucle-dog-bed-dog-bed-bundle')){
    
     var discc = 000;
     var addDisc = 0000;
   }

   if(window.location.href.includes('calming-dog-bed-weighted-blanket')){
    
     var discc = 0;
     var addDisc = 0;
   }

   if(window.location.href.includes('boucle-dog-bed-weighted-blanket')){
    
     var discc = 0;
     var addDisc = 0;
   }

   if(window.location.href.includes('/car-bed-pet-odour-eliminator-bundle')){
     var discc = 0;
     var addDisc = 0;
   }
  if(window.location.href.includes('/boucle-car-bed-bundle')){
     var discc = 0;
     var addDisc = 0;
   }
   if(window.location.href.includes('/calming-dog-bed-throw')){
     var discc = 0;
     var addDisc = 0;
   }


    if(window.location.href.includes('/luxury-boucle-dog-bed-throw-bundle')){
     var discc = 0;
     var addDisc = 0;
   }
   if(window.location.href.includes('/calming-dog-bed-premium-dog-car-bed-bundle')){
     var discc = 0;
     var addDisc = 0;
   }

   if(window.location.href.includes('/premium-teddy-bed-spare-cover-bundle')){
     var discc = 0;
     var addDisc = 0;
   }

    


   if(window.location.href.includes('/calming-bed-calming-spare-cover-car-bed')){
    var newPrice = pr1 + pr2 + pr3 - discc
    var compPrice = pr1 + pr2 + pr3 + cdiscc + addDisc
    jQuery('.sale-price').eq(0).html(currency + Math.round((newPrice/100)).toFixed(2) );
    jQuery('.product__price--compare').eq(0).html(currency + (compPrice/100).toFixed(2) );
   }
   else{
     var newPrice = pr1 + pr2
    var compPrice = pr1 + pr2 + cdiscc
    jQuery('.sale-price').eq(0).html(currency + (newPrice/100).toFixed(2));
    jQuery('.product__price--compare').eq(0).html(currency + Math.round((compPrice/100)).toFixed(2) );
   }

   
 }   
jQuery('.variant-input-wrap select').change(function(){

  updatePrice()
  

    var src = jQuery(this).find('option:selected').eq(0).attr('featured-image-src').replace('products/','').split('.')[0];
  console.log(src);
    jQuery('a.product__thumb[href*="'+src+'"]').eq(0).click();
  
   var variant1Presale = parseInt(jQuery('.variant-input-wrap select option:selected').eq(0).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(0).attr('availability') == "continue"
    var variant2Presale = parseInt(jQuery('.variant-input-wrap select option:selected').eq(1).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(1).attr('availability') == "continue"
  var variant2SoldOut  = parseInt(jQuery('.variant-input-wrap select option:selected').eq(1).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(1).attr('availability') == "deny";
  var variant1SoldOut = parseInt(jQuery('.variant-input-wrap select option:selected').eq(0).attr('inventory-qty')) < 1 && jQuery('.variant-input-wrap select option:selected').eq(0).attr('availability') == "deny";

    console.log(variant1Presale);
    console.log(variant2Presale);

  if(variant1SoldOut || variant2SoldOut){
     jQuery('.product-single__form').eq(0).addClass('sold-out-bundle');
    jQuery('.product-single__form').eq(0).removeClass('two-pre-sale');
    jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
  }
    else{
      jQuery('.product-single__form').eq(0).removeClass('sold-out-bundle');
    
    
  if(variant1Presale && variant2Presale){
        jQuery('.product-single__form').eq(0).addClass('two-pre-sale');
        jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
  }
   else if(variant1Presale || variant2Presale){
     jQuery('.product-single__form').eq(0).addClass('one-pre-sale');
  }
  
  else{
    jQuery('.product-single__form').eq(0).removeClass('two-pre-sale');
    jQuery('.product-single__form').eq(0).removeClass('one-pre-sale');
   
  }

      }

   
}); 

   setInterval(function(){ 
jQuery('form button.add-to-cart').removeClass('disabled');
     jQuery('form button.add-to-cart').removeAttr('disabled');
}, 100);
  jQuery(document).ready(function(){
 jQuery('form button.add-to-cart').click(function(e){
   e.preventDefault();
   var var1 = jQuery(".variant-input-wrap select option:selected").eq(0).attr('data-id');
   var var2 = jQuery(".variant-input-wrap select option:selected").eq(1).attr('data-id');

   if(window.location.href.includes('/calming-bed-calming-spare-cover-car-bed')){
     var var3 = jQuery(".variant-input-wrap select option:selected").eq(2).attr('data-id');
       window.location.href =  '/cart/add?id[]=' + var1 + '&quantity=1&id[]=' + var2 + '&quantity=1&id[]=' + var3 + '&quantity=1'
   }

   else{
      window.location.href =  '/cart/add?id[]=' + var1 + '&quantity=1&id[]=' + var2 + '&quantity=1'
   }
    
   
   
   
  
}); 

});
 
}
  }
    });



var ur = window.location.href;
if(ur.includes('/cart')){
  jQuery(document).ready(function(){
var hnames = jQuery('.cart__product-name');
    var hasAddon = false;
    for(var i = 0; i < hnames.length; i++){
      if(hnames.eq(i).html().includes('Calming Dog Bed Covers Add-on')){
        hasAddon = true;
      }
    }

    if(hasAddon){
      jQuery('body').addClass('has-Add-on');
    }

     setInterval(function(){ 
if(!jQuery('body').hasClass('checkout-redirect') && jQuery('.lb-addon-popup-continue-btn').length && jQuery('body').hasClass('has-Add-on')) {
    jQuery('body').addClass('checkout-redirect');
    
	document.querySelectorAll('.lb-addon-popup-continue-btn')[0].click();
  clearInterval();
}
       else if(jQuery('.lb-addon-popup-continue-btn').length){
  jQuery('body').addClass('show-upsell-popup');
       }
    
}, 50);
    
});
}

var ur = window.location.href;
if(ur.includes('/collections/cover')){
  
    var pimg = 0; var timerpimg = setInterval(function(){
  if(jQuery('.grid-product__image-mask source').length) {
    jQuery('.grid-product__image-mask source').eq(0).attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/darkgrey-bed-coveronly.jpg?v=1667872403');
	jQuery('.grid-product__image-mask source').eq(0).attr('srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/darkgrey-bed-coveronly.jpg?v=1667872403');
    jQuery('.grid-product__image-mask source').eq(1).attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/teddy-coveronly.jpg?v=1667872403');
	jQuery('.grid-product__image-mask source').eq(1).attr('srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/teddy-coveronly.jpg?v=1667872403');	

    jQuery('.grid-product__image-mask source').eq(2).attr('data-srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/teddy-coveronly_895ac325-47af-4da6-8501-caac3c36fab6.jpg?v=1698797999');
	jQuery('.grid-product__image-mask source').eq(2).attr('srcset', 'https://cdn.shopify.com/s/files/1/0280/3790/6505/files/teddy-coveronly_895ac325-47af-4da6-8501-caac3c36fab6.jpg?v=1698797999');	
   

clearInterval(timerpimg);}if( pimg > 200){clearInterval(timerpimg);}pimg++;}, 50);
   
  } 


if(ur.includes('/cart')){
  jQuery(document).ready(function(){
    console.log('cart ready')
  var hasBed = false;
jQuery('a.h4.cart__product-name').each(function(){
  if(!jQuery(this).text().includes('Calming Dog Bed Covers') && !jQuery(this).text().includes('Double Weighted Luxury Blanket') && !jQuery(this).text().includes('Premium Teddy Bed Spare Cover')){
        hasBed = true;
  }
});

if(hasBed){
  var sss = 0; var timersss = setInterval(function(){
  if(jQuery('.stack-discounts-input-wrapper').length) {
	jQuery('.stack-discounts-input-wrapper').hide();
    var hh = 0; var timerhh = setInterval(function(){
  if(jQuery('.stack-discounts-close-tag').eq(0).length) {
    
	//jQuery('.stack-discounts-close-tag').eq(0).click();
clearInterval(timerhh);}if( hh > 200){clearInterval(timerhh);}hh++;}, 50);
    
clearInterval(timersss);}if( sss > 200){clearInterval(timersss);}sss++;}, 50);

}
    
   setInterval(function(){
     var discs = jQuery('.cart__discount span');
     var totalOffDiscount = 0
     for(var i = 0; i < discs.length; i++){
       totalOffDiscount += parseInt(discs.eq(i).html())
     }
     
     if(jQuery('.stack-discounts-tag').length){
       jQuery('.stack-discounts-discount.copy').addClass('active')
     }
     if(jQuery('.stack-discounts-tag.custom').length == 0 && jQuery('.hasCustomDiscount').length){
      jQuery('.stack-discounts-tags-wrapper > div').eq(0).prepend(jQuery('<div class="stack-discounts-tag custom" data-value="'+currency+totalOffDiscount+' OFF ADD TO CART" data-is-automatic="1"><span><span class="stack-discounts-tag-text">'+currency+totalOffDiscount+' OFF ADD TO CART</span><span class="stack-discounts-tag-value">'+currency +totalOffDiscount+'.00</span></span></div>'))
     }
     if(jQuery('#stack-discounts-container').attr('data-discount-value') != null){
       
       var discount =parseFloat(jQuery('#stack-discounts-container').attr('data-discount-value'));
     }
     else{
       var discount = 0
     }

     var totalDiscount = discount + totalOffDiscount;
     
     jQuery('.stack-discounts-discount span.stack-discounts-discount-value').html(currency + totalDiscount.toFixed(2));
     
     var amt = parseFloat(jQuery('span#stack-discounts-subtotal-value').html().replaceAll(',','').substring(1));
     var compareAmt = amt + totalDiscount;
   
     if(jQuery('span#stack-discounts-subtotal-value strike').length == 0 && totalDiscount > 0){
       //jQuery('span#stack-discounts-subtotal-value').html(Math.floor(parseFloat(jQuery('span#stack-discounts-subtotal-value').html()));)
       jQuery('span#stack-discounts-subtotal-value').prepend(jQuery('<strike class="computed">' + currency + compareAmt.toFixed(2)+'</strike>'));
     }
     else if(jQuery('.computed').length == 0){
      
       var curCompareAmt = parseFloat(jQuery('span#stack-discounts-subtotal-value strike').html().substring(1));
        
       compareAmt = curCompareAmt + totalOffDiscount;
       jQuery('span#stack-discounts-subtotal-value strike').html(currency + compareAmt.toFixed(2));
       jQuery('span#stack-discounts-subtotal-value strike').addClass('computed');
     }
     
}, 10000);
});
  
}

var ur = window.location.href;
if(ur.includes('products/dog-toy-take-away-coffee')){
  window.location.href = '/collections/dog-beds'
}

var ur = window.location.href;
if(ur.includes('/orthopedic-memory-foam-bed')){
  jQuery(document).ready(function(){
jQuery('body').addClass('memory-foam');
});
  
}

var ur = window.location.href;
if(ur.includes('/cart')){
  var varId = 39322283606089
   setInterval(function(){ 
var sum = 0;
     var qtys = jQuery('.cart__row:not([data-id="'+varId+'"])[data-id] .cart__product-qty');
     for(var i = 0; i < qtys.length; i++){
       sum += parseInt(qtys.eq(i).val());
     }
     if(sum == 0){
       jQuery('[data-id="'+varId+'"]').attr('data-sum', sum);
     jQuery('[data-id="'+varId+'"] .cart__product-qty').val(sum).change();
     }
     else{
       jQuery('[data-id="'+varId+'"]').attr('data-sum', 1);
     jQuery('[data-id="'+varId+'"] .cart__product-qty').val(1).change();
     }
     
     
}, 50);
}



var ur = window.location.href;

 function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 1 * 60 * 60 * 1000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

if (ur.includes("?disc=freetoy")) {
    setCookie("FreeToy", "1", 1);
   
}
//setCookie("FreeToy", "1", 1);
var ur = window.location.href;
if(ur.includes('/product') && !document.title.includes('Jumper')){
  console.log('testsing');
jQuery(document).ready(function(){
  var curCTA = "BUY NOW AND SAVE " + currency + jQuery('[discount-amount]').attr('discount-amount');
  
  if(jQuery('.no-stock').length && jQuery('.premium-dog-car-bed .variant-input[data-value="M/L"] input:checked').length == 0){
    var curCTA = "BUY PRE-SALE"
  }
   setInterval(function(){ 
       var curCTA = "BUY NOW AND SAVE " + currency + jQuery('[discount-amount]').attr('discount-amount');
         if((jQuery('.no-stock').length || jQuery('.two-pre-sale').length || jQuery('.one-pre-sale').length) && jQuery('.premium-dog-car-bed .variant-input[data-value="M/L"] input:checked').length == 0){
    var curCTA = "BUY PRE-SALE"
  }

     if(jQuery('[discount-amount]').attr('discount-amount') == ""){
       var curCTA = "BUY NOW AND SAVE " + currency + jQuery('[discount-amount]').attr('discount-amount');
     }

     if(jQuery('.no-stock').length && jQuery('.premium-dog-car-bed .variant-input[data-value="M/L"] input:checked').length == 0){
    jQuery('.product-single__form').addClass("for-presale");
  }
  else{
    jQuery('.product-single__form').removeClass("for-presale");
  }
if(jQuery('.add-to-cart[disabled]').eq(0).length == 0){
  
 // jQuery('.add-to-cart').text("BUY NOW")
  
}
     else{
        //jQuery('.add-to-cart').text("")
     }
}, 50);
});


  var afp = 0; var timerafp = setInterval(function(){
  if(jQuery('square-placement').length) {
	jQuery('.sale-price').eq(0).after(jQuery('square-placement').eq(0));
    jQuery('.price-saved-amount').eq(0).after(jQuery('square-placement').eq(0));
clearInterval(timerafp);}if( afp > 200){clearInterval(timerafp);}afp++;}, 50);
  
   setInterval(function(){ 
     if(jQuery('a.btn.klaviyo-bis-trigger').length && jQuery('a.btn.klaviyo-bis-trigger[style*="none"]').length == 0){
      jQuery('body').addClass('sold-outt'); 
     }
     else{
       jQuery('body').removeClass('sold-outt'); 
     }
}, 500);
 jQuery(document).ready(function(){
jQuery('form button.add-to-cart').click(function(e){
  var counter = getCookie("FreeToy");

  if(counter){
   
    e.preventDefault();
    e.stopPropagation();
    var qty = parseInt(jQuery('.js-qty__num').val());
 var variant = jQuery('.product-single__variants').val();
   window.location.href =  "/cart/add?id[]=39322283606089&quantity="+qty+"&id[]="+variant+"&quantity="+qty
   
  }
}); 
}); 
}



jQuery(document).scroll(function() {
 
    changeBelowImage()
  
}); 
function changeBelowImage(){
var ur = window.location.href;
if(document.body.className.includes('template-product')){
  jQuery(document).ready(function(){


  

  var img1 = jQuery('#footer-prod-img1').attr('data-url');
  var img2 = jQuery('#footer-prod-img2').attr('data-url');

     setInterval(function(){ 
      jQuery('img.pswp__img.pswp__img--placeholder + img').eq(0).attr('src', jQuery('img.pswp__img.pswp__img--placeholder').eq(0).attr('src'));
      
}, 500);
    if(!img1.includes('no-image')){
      jQuery('.image-row__image img').eq(0).attr('data-srcset', img1);
	jQuery('.image-row__image img').eq(0).attr('srcset', img1); 
      
    }
    if(!img2.includes('no-image')){
      jQuery('.image-row__image img').eq(1).attr('data-srcset', img2);
	jQuery('.image-row__image img').eq(1).attr('srcset', img2);
      jQuery('img.pswp__img').eq(2).attr('src', img2);
      jQuery('img.pswp__img').eq(3).attr('src', img2);
    }

   });
  } 

}
jQuery(document).ready(function(){
var ur = window.location.href;
if(ur.includes('#sizingchart')){
   setTimeout(function(){ 


  jQuery('html, body').animate({
        scrollTop: jQuery('[href="#sizingchart"]').offset().top
    }, 50);
     }, 1000);
}
});


var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
   jQuery('body').addClass('no-reviews');
var spm = 0; var timerspm = setInterval(function(){
  if(jQuery('span.enormText').length || jQuery('.enorm-reviews .review-count .total-count').text() != 0) {
	jQuery('body').removeClass('no-reviews');
clearInterval(timerspm);}if( spm > 200){clearInterval(timerspm);}spm++;}, 50);
   
    setTimeout(function(){ 
jQuery('.sash-mid-badges-outer-container').eq(0).before(jQuery('div#faq-section').eq(0).parent());
jQuery('.sash-mid-badges-outer-container').eq(0).after(jQuery('.shopify-section[id*="hero-video"]'))
     jQuery('.sash-mid-badges-outer-container').eq(0).after(jQuery('#mgraphic')) 
}, 100);

}); 
}



jQuery(document).ready(function(){



var ur = window.location.href;
if(ur.includes('/product')){
  
   var kl = 0; var timerkl = setInterval(function(){
   if(jQuery('.ks-html-content').length) {
    jQuery('.ks-html-content').eq(0).html(jQuery('.size-guide').eq(0).html());
    var ur = window.location.href;
if(ur.includes('calming-dog-bed-premium-dog-car-bed-bundle') || ur.includes('calming-bed-calming-spare-cover-car-bed')){
 jQuery('.ks-html-content').eq(0).append(jQuery('.size-guide').eq(1).clone()); 
}

if(ur.includes('boucle-car-bed-bundle')){
 jQuery('.ks-html-content').eq(0).append(jQuery('.size-guide').eq(1).clone()); 
}   

    
if(ur.includes('calming-dog-bed-throw')){
 jQuery('.ks-html-content').eq(0).append(jQuery('.size-guide').eq(1).clone()); 
}   
if(ur.includes('calming-dog-bed-weighted-blanket')){
 jQuery('.ks-html-content').eq(0).append(jQuery('.size-guide').eq(1).clone()); 
}       
if(ur.includes('boucle-dog-bed-weighted-blanket')){
 jQuery('.ks-html-content').eq(0).append(jQuery('.size-guide').eq(1).clone()); 
}            
   
	
clearInterval(timerkl);}if( kl > 200){clearInterval(timerkl);}kl++;}, 50);
  
   setInterval(function(){ 
var inv = jQuery('.product__inventory').html();
     if(window.inventories[jQuery('.product-section').attr('data-section-id')][jQuery('.product-single__variants').val()] != null && window.inventories[jQuery('.product-section').attr('data-section-id')][jQuery('.product-single__variants').val()].quantity <= 0){

      jQuery('.product-single__meta').addClass('no-stock');
     }
     else{
        jQuery('.product-single__meta').removeClass('no-stock');
     }
}, 100);
  
   jQuery('.popup-preorder-btn').click(function(e){
    e.preventDefault();
  jQuery('form button.add-to-cart').click();
}); 
  
  jQuery('.preorder-text-btn').click(function(e){
  jQuery('body').addClass('popup-show');
}); 
   jQuery('button.close.klaviyo-bis-close').click(function(){
  jQuery('body').removeClass('popup-show');
}); 
var af = 0;
   setInterval(function(){ 
//jQuery('strong.afterpay-instalments').eq(0).html(jQuery('strong.afterpay-instalments').eq(0).html().replace('AUD' ,''));
}, 500);
var timeraf = setInterval(function(){
  if(jQuery('p.afterpay-paragraph').length) {
	//jQuery('.product__price').eq(0).before(jQuery('<span class="sashbeds-compare-price"></span>'))
    jQuery('span.afterpay-text1').eq(0).html('or 4 payments of ');
    jQuery('span.afterpay-text2').eq(0).html('with ');
    
    
    jQuery('p.afterpay-paragraph').click(function(){
document.querySelectorAll('a.afterpay-link')[0].click();
}); 
     clearInterval(timeraf);
  }
if( af > 200){
     clearInterval(timeraf);
}
af++;
}, 50);

  
  
  var kc = 0;
var timerkc = setInterval(function(){
  if(jQuery('.ks-chart-container.sizing-chart-container').length) {
	jQuery('.sash-cont >.variant-wrapper.variant-wrapper--button.js').eq(0).append(jQuery('.ks-chart-container.sizing-chart-container').eq(0));
     clearInterval(timerkc);
  }
if( kc > 200){
     clearInterval(timerkc);
}
kc++;
}, 50);
  sticky();
 function sticky(){
var ur = window.location.href;
if(ur.includes('/product') && !ur.includes('card') && !ur.includes('e814dc860e9eceb139bca9f29315e380')){
  
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="sash-st-container" id="sash-st-containerID"> <div class="sash-st-container__outer"><div class="sash-product-cont"><div class="sash-product-image" ></div><div class="sash-col"><div class="sash-product-name"></div><div class="sash-product-reviews"><span class="icon_color enap-star"></span><span class="icon_color enap-star"></span><span class="icon_color enap-star"></span><span class="icon_color enap-star"></span><span class="icon_color enap-star"></span></div><div class="sash-product-price"></div></div></div> <div class="sash-st-container__inner"> <div class="sash-select-container"> <div class="sash-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="sash-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="sash-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="sash-st-item_column__button"><div class="sash-st-item__button" rel="nofollow">SELECT OPTIONS</div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('sash-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.sash-product-name').html(jQuery('.product-single__title').eq(0).html());
  
    jQuery('.sash-product-image').eq(0).html(jQuery('.product__thumb-item img').eq(1).parent().html());
  
  
  
 
function populateOptions(select, labels){
  var selected = labels.eq(0).prop('selectedIndex');
  labels = labels.eq(0).find('option');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
        
      
    
      var t = document.createTextNode(labels.eq(i).html());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
    	if(i ==0){
          select.removeChild(select.firstElementChild);
          
          
        }
    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.sash-st-item__button').click(function(){
   if(!jQuery('.sash-st-item__button').hasClass("sash-st-disabled")){
jQuery('html, body').animate({
        scrollTop: jQuery('h1.h2.product-single__title').offset().top - 80
    }, 500);
     
      }
    
   
  });
  
    
    
};
  
     function checkIfDisabled() {

     }
//checkIfDisabled();
  jQuery('.r > label').click(function(){
   		checkIfDisabled();
});

     
     
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        mc.addListener(slideShow);    
        
    var elem = document.getElementById("sash-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('sash-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('sash-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('form button.add-to-cart').eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
                             
}


}           
 
    
    
}
  });
var ur = window.location.href;
if(ur.includes('#sizeGuide')){
  console.log('heressss!');
  jQuery(document).ready(function(){
 setTimeout(function(){ 
jQuery('html, body').animate({
        scrollTop: jQuery('.sizing-guide').offset().top - 100
    }, 200);
}, 500);
	
});

  

}



var ur = window.location.href;
if(ur.includes('/cart')){
  jQuery(document).ready(function(){
     setTimeout(function(){ 


if($('[data-product-id="7005247963209"]').length && $('[data-product-handle="premium-dog-car-bed-add-on-20-off"]').length == 0) {
$('[data-product-id="7005247963209"] a.btn.btn--tertiary').click();
}
else if($('[data-product-handle="premium-dog-car-bed-add-on-20-off"]').length 
        && $('[data-product-id="7005247963209"]').length == 0 
        && $('[data-product-id="7035458781257"]').length == 0
       && $('[data-product-handle="luxury-boucle-dog-bed-bundled"]').length == 0
        && $('[data-product-handle="luxury-boucle-dog-bed-bundled-1"]').length == 0
       && $('[data-product-handle="calming-dog-bed"]').length == 0
        && $('[data-product-handle="calming-dog-bed-2"]').length == 0
       && $('[data-product-handle="calming-dog-bed-covers-add-on"]').length == 0
       && $('[data-product-handle="boucle-luxury-comforting-bed"]').length == 0) {
$('[data-product-handle="premium-dog-car-bed-add-on-20-off"] a.btn.btn--tertiary').click();
}  



if($('[data-product-id="6992358342729"]').length && $('[data-product-id="6985734324297"]').length == 0 && $('[data-product-id="6992356606025"]').length == 0) {
$('[data-product-id="6992358342729"] a.btn.btn--tertiary').click();
}
else if($('[data-product-id="6992356606025"]').length && $('[data-product-id="6985734324297"]').length == 0 && $('[data-product-id="6992358342729"]').length == 0) {
$('[data-product-id="6992356606025"] a.btn.btn--tertiary').click();
}
else if($('[data-product-id="6985734324297"]').length && $('[data-product-id="6992358342729"]').length == 0 && $('[data-product-id="6992356606025"]').length == 0) {
$('[data-product-id="6985734324297"] a.btn.btn--tertiary').click();
}

if($('[data-product-handle="calming-dog-bed-1"]').length  
    && $('[data-product-handle="premium-dog-car-bed-add-on-20-off"]').length == 0 
    && $('[data-product-handle="double-weighted-luxury-blanket"]').length == 0 
    && $('[data-product-handle="deluxe-dog-throw"]').length == 0 
     && $('[data-product-handle="calming-dog-bed-covers-add-on"]').length == 0
   && $('[data-product-handle="premium-dog-car-bed-bundled"]').length == 0
   && $('[data-product-handle="double-weighted-luxury-blanket-bundled"]').length == 0
 ) {
$('[data-product-handle="calming-dog-bed-1"] a.btn.btn--tertiary').click();
}  


    if($('[data-product-handle="luxury-boucle-dog-bed-bundled-1"]').length  
    && $('[data-product-handle="luxury-boucle-dog-bed-spare-cover"]').length == 0 
    && $('[data-product-handle="premium-dog-car-bed-add-on-20-off"]').length == 0
    && $('[data-product-handle="boucle-luxury-comforting-bed"]').length == 0
   && $('[data-product-handle="deluxe-dog-throw"]').length == 0
    && $('[data-product-handle="luxury-boucle-dog-bed-bundled"]').length == 0
   && $('[data-product-handle="double-weighted-luxury-blanket"]').length == 0) {
$('[data-product-handle="luxury-boucle-dog-bed-bundled-1"] a.btn.btn--tertiary').click();
}     

 if($('[data-product-handle="luxury-boucle-dog-bed-bundled"]').length  
    && $('[data-product-handle="luxury-boucle-dog-bed-spare-cover"]').length == 0 
    && $('[data-product-handle="premium-dog-car-bed-add-on-20-off"]').length == 0
    && $('[data-product-handle="boucle-luxury-comforting-bed"]').length == 0
   && $('[data-product-handle="deluxe-dog-throw"]').length == 0
    && $('[data-product-handle="luxury-boucle-dog-bed-bundled-1"]').length == 0
   && $('[data-product-handle="double-weighted-luxury-blanket"]').length == 0) {
$('[data-product-handle="luxury-boucle-dog-bed-bundled"] a.btn.btn--tertiary').click();
}  


 if($('[data-product-handle="luxury-boucle-dog-bed-bundled-20-off"]').length  
    && $('[data-product-handle="luxury-boucle-dog-bed-spare-cover"]').length == 0
    && $('[data-product-handle="luxury-boucle-spare-cover"]').length == 0
   && $('[data-product-handle="deluxe-dog-throw"]').length == 0
    && $('[data-product-handle="double-weighted-luxury-blanket-bundled"]').length == 0
    && $('[data-product-handle="deluxe-dog-throw-bundled"]').length == 0
   && $('[data-product-handle="double-weighted-luxury-blanket"]').length == 0) {
$('[data-product-handle="luxury-boucle-dog-bed-bundled-20-off"] a.btn.btn--tertiary').click();
}  
       

if($('[data-product-handle="premium-marble-dog-bowl-free"]').length  
    && $('.cart__row[data-product-handle]:not([data-product-handle="premium-marble-dog-bowl-free"])').length == 0 ) {
$('[data-product-handle="premium-marble-dog-bowl-free"] a.btn.btn--tertiary').click();
}  


if($('[data-product-handle="mister-woof-teddy-jumper"]').length  
    && $('.cart__row[data-product-handle]:not([data-product-handle="mister-woof-teddy-jumper"])').length == 0 ) {
$('[data-product-handle="mister-woof-teddy-jumper"] a.btn.btn--tertiary').click();
}         

if($('[data-product-handle="premium-teddy-bed-10-off"]').length  
    && $('[data-product-handle="premium-teddy-bed-spare-cover"]').length == 0
  && $('[data-product-handle="premium-teddy-bed-spare-cover-bundled"]').length == 0) {
$('[data-product-handle="premium-teddy-bed-10-off"] a.btn.btn--tertiary').click();
}      

       
       }, 100);
});
  

}




var ur = window.location.href;
if(ur.includes('/cart')){
 function checkDiscountCode() {
    // Get the value of the 'discount_code' cookie
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const discountCodeCookie = cookies.find(cookie => cookie.startsWith('discount_code='));
    if (!discountCodeCookie) {
        return;
    }
    const discountCode = decodeURIComponent(discountCodeCookie.split('=')[1]);

    // Check if the discount code contains 'FRENZY-25CALM'
    if (discountCode.includes('FRENZY-25CALM') ) {
        document.body.classList.add('frenzy-25calm');
      document.body.classList.add('special-discount');
    }
   if (discountCode.includes('FRENZY-30CAR')) {
        document.body.classList.add('frenzy-30car');
     document.body.classList.add('special-discount');
    }

   if (discountCode.includes('FRENZY-30COUCH')) {
        document.body.classList.add('frenzy-30couch');
     document.body.classList.add('special-discount');
    }
   if (discountCode.includes('FRENZY-SS1502B')) {
        document.body.classList.add('frenzy-ss');
     document.body.classList.add('special-discount');
    }
}

// Call the function when the document is ready
document.addEventListener('DOMContentLoaded', checkDiscountCode); 
}

var ur = window.location.href;
if(ur.includes('/cart')){
   setInterval(function(){ 
var subps = jQuery('span.cart__price.cart__discount.original-price');
var totap = jQuery('span.cart__price.cart__discount:not(.original-price)');
var totalCom = 0
var totalPrice = 0;
for(var x = 0; x < totap.length; x++){
  if(subps.eq(x).html() != null){
    var subp = parseFloat(subps.eq(x).html().substring(1))
  }

  if(subp == null){
   var subp = 0;
  }
  console.log('test');
  console.log(subp)
    var tota = parseFloat(totap.eq(x).html().substring(1))

    totalCom += subp;
    totalPrice += tota
}
if(totalCom < totalPrice){
  
}
var totalSavingss = totalCom - totalPrice;
jQuery('span.totalSavings').html("$" + totalSavingss.toFixed(2) + "")
if(totalCom < totalPrice){
  jQuery('.savings.show').remove()
  jQuery('span#stack-discounts-subtotal-value').html(`<span id="stack-discounts-subtotal-value">$`+totalPrice.toFixed(2)+`</span>`)
}
     else{
       jQuery('span#stack-discounts-subtotal-value').html(`<span id="stack-discounts-subtotal-value"><strike class="computed">$`+totalCom.toFixed(2)+`</strike>$`+totalPrice.toFixed(2)+`</span>`)
     }

}, 500);
 
}

